import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useLDReady } from './ldProvider';

export const FeatureFlagContext = createContext();

const mapFlagsToCspConfiguration = (flags) => ({
  IsPayNowEnabled: flags.opsPayNowEnabled,
  IsLegacyPaymentEnabled: flags.configLegacyPaymentModeEnabled,
  IsNotificationPreferencesEnabled: flags.configNotificationPreferencesEnabled,
  IsKontentAIPreviewEnabled: flags.configKontentAiPreviewModeEnabled,
  IsLiteModeEnabled: flags.opsLiteModeEnabled,
  IsLiveVetEnabled: flags.configLiveVetEnabled,
  IsExcessEnabled: flags.configExcessEnabled,
  IsWhatsCoveredEnabled: flags.configWhatsCoveredEnabled,
  IsLEC: flags.configLecEnabled,
  IsShortBirthdate: flags.configShortBirthDateEnabled,
  IsDualPortal: flags.configDualPortalEnabled,
  IsInstalmentProcessingEnabled: flags.tempInstalmentProcessingEnabled,
  IsV3PenTestRemediationEndpointsEnabled: flags.tempV3MwPenTestRemediationEndpointsEnabled,
  IsFallbackModeMiddlewareApiEnabled: flags.configFallbackModeMiddlewareApiEnabled,
  IsRenewalHubEnabled: flags.configRenewalHubEnabled,
  IsCreatePortalUserTokenEnabled: flags.tempCreatePortalUserTokenEndpoint
});

export const FeatureFlagContextProvider = ({ children }) => {
  const flags = useFlags();
  const isLdReady = useLDReady();

  const cspConfigs = useMemo(
    () => ({
      cspConfiguration: mapFlagsToCspConfiguration(flags),
      isCspConfigLoading: !isLdReady
    }),
    [flags, isLdReady]
  );

  // TODO: remove this once LaunchDarkly launched and proven
  // eslint-disable-next-line no-console
  console.log('flags', flags);
  return <FeatureFlagContext.Provider value={cspConfigs}>{children}</FeatureFlagContext.Provider>;
};

FeatureFlagContextProvider.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any
};

export default { FeatureFlagContext, FeatureFlagContextProvider };
